import React, { useState } from "react";
import { Container, Form, Image } from "react-bootstrap";
import Media from "react-media";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { DropDownBoxCrret } from "../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import {
  NewInputText,
  NewSelectBoxInput,
  SelectBoxMUiInputComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
  ReusableOnboardingMapButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { CurrencyPicker } from "../SuperAdminAddVendorComponent/restaurantDetailsOnboarding/CurrencyPicker";
import { TimeZoneCustom } from "../SuperAdminAddVendorComponent/restaurantDetailsOnboarding/TimeZoneCustom";
import { IconButton, TextField } from "@material-ui/core";
import SimpleReactLightbox from "simple-react-lightbox";
import Alert from "react-s-alert";
import Slider from "react-slick";
import axios from "axios";

import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { FormHelperText } from "@material-ui/core";
import { SuggestNewButton } from "../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import SingleImageReusableComponent from "../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";
import {
  imageUploadSize,
  serverApi,
  videoUploadSize,
} from "../../../../config/Keys";
import AlertDialogProgress from "../../../reusableComponents/allPopupReusable/DialogProgression";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import { Switch } from "react-router";
const settings = {
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const revenueData = [
  { id: 1, name: "Accounting / Finance", value: "Accounting / Finance" },
  { id: 2, name: "Assistant Manager", value: "Assistant Manager" },
  { id: 3, name: "Back Office", value: "Back Office" },
  { id: 4, name: "Chef", value: "Chef" },
  { id: 5, name: "Delivery", value: "Delivery" },
  { id: 6, name: "Front Office", value: "Front Office" },
  { id: 7, name: "General Manager", value: "General Manager" },
  { id: 8, name: "Hostess. / Host", value: "Hostess. / Host" },
  { id: 9, name: "Manager", value: "Manager" },
  { id: 10, name: "Owner", value: "Owner" },
  { id: 11, name: "Other", value: "Other" },
  { id: 12, name: "Proprietor", value: "Proprietor" },
  { id: 13, name: "Receptionist", value: "Receptionist" },
  { id: 14, name: "Sue-Chef", value: "Sue-Chef" },
  { id: 15, name: "Waiter", value: "Waiter" },
];

function SuperAdminAddNonProfitOrg(props) {
  const [state, setState] = useState({
    enquiry_email: [],
    contact_detail: [],
    phone_numbers: [],
    enquiry_emails: [],
  });
  const [contacts_array, setContacts] = useState([]);
  const [disp, setDisp] = useState(7);
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Container fluid>
              {disp === 0 && (
                <div className="onboarding_process_screen-left-mapinside">
                  <div>
                    <TopTextReusableComponent
                      headingText="Add Non-Profit Organization"
                      headingParagraph="Please Enter Non-Profit Org Information only some of this information is displayed to the end User"
                    />
                  </div>
                  <Form noValidate>
                    {/* onSubmit={ handleSubmit} */}
                    <div className="mt-5">
                      <div className="col-12 p-0">
                        <NewInputText
                          name="name"
                          inputType="text"
                          labelText="Business Name*"
                          helpTextDisplay={true}
                          helperTextBottom="(Business names on Amealio need to be written as they appear on the board outside the establishment)"
                        />
                      </div>
                      <div className="col-12 p-0 text-area-labelText-padding">
                        <NewInputText
                          extraClass="text-area-labelText-padding-two"
                          name="address"
                          rows="4"
                          multiline={true}
                          labelText="Restaurant Address"
                          helpTextDisplay={true}
                          helperTextBottom="(Business Address on Amealio need to be written to help users navigate to the place, please include all the details )"
                        />
                      </div>
                      <div className="col-12 p-0">
                        <div className="row">
                          <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                            <NewInputText name="area" inputType="text" />
                          </div>
                          <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                            <NewInputText
                              name="city"
                              inputType="text"
                              labelText="City"
                            />
                          </div>
                          <div className="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
                            <NewInputText
                              name="pinCode"
                              inputType="number"
                              labelText="Pin/Zip Code"
                            />
                          </div>
                        </div>
                      </div>
                      {state.enquiry_email.map((email, index) => (
                        <div
                          className="row align-items-center mb-4"
                          key={index}
                        >
                          <div className="col-9">
                            <NewInputText
                              extraClass="mt-0 mb-0"
                              name="enquiry_email"
                              inputType="email"
                              labelText="Enquiry Email*"
                            />
                          </div>

                          <div className="col-3 restaurant_details_onboarding_minus_button">
                            {state.enquiry_email.length > 1 ? (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Delete"
                                  // onClick={onEmailDeleteHandler(index)}
                                  fontIcon="fa fa-trash-o"
                                  colorCss="delete"
                                />
                              </div>
                            ) : (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Add Another"
                                  // onClick={onEmailAddHandler}
                                  fontIcon="fa fa-plus"
                                  colorCss="blue"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {state.enquiry_email.length > 1 ? (
                        <div className="col-12 mb-3 p-0 restaurant_details_onboarding_minus_button add_email_button mt-0">
                          <div>
                            <AddButtonIconComponent
                              buttonText="Add Another Email"
                              // onClick={onEmailAddHandler}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </div>
                        </div>
                      ) : null}
                      {/* <Form.Label className="col-12 mt-3 pl-0 restaurant_details_onboarding_mobile_number">
                        Mobile Number
                      </Form.Label> */}
                      {state.contact_detail.map((phone, index) => (
                        <div className="row mb-4" key={index}>
                          <div className="col-4 col-xl-3">
                            <Form.Group
                              className="reusableInputComponent-main mb-0"
                              controlId={"country_code"}
                            >
                              <div className="input-phone-country-code-reusable">
                                <select className="w-100" name="country_code">
                                  <option value={""}>test</option>
                                </select>
                              </div>
                            </Form.Group>
                          </div>
                          <div className="col-5 col-xl-6 pl-0">
                            <NewInputText
                              extraClass="mb-0"
                              name="mobile_no"
                              inputType="number"
                              maxLength="10"
                            />
                          </div>
                          <div className="col-3 restaurant_details_onboarding_minus_button">
                            {state.contact_detail.length > 1 ? (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Delete"
                                  // onClick={onPhoneDeleteHandler(index)}
                                  fontIcon="fa fa-trash-o"
                                  colorCss="delete"
                                />
                              </div>
                            ) : (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Add Another"
                                  // onClick={onPhondeAddHandler}
                                  fontIcon="fa fa-plus"
                                  colorCss="blue"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {state.contact_detail.length > 1 ? (
                        <div className="col-12 pl-0 restaurant_details_onboarding_minus_button add_email_button mt-0">
                          <div>
                            <AddButtonIconComponent
                              buttonText="Add Another Phone Number"
                              // onClick={onPhondeAddHandler}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </div>
                        </div>
                      ) : null}
                      <div className="row restaurant_details_onboarding_country_box mb-md-3 mb-lg-3 mb-xl-3 mt-4">
                        <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 new_Input_field_Section">
                          <NewSelectBoxInput
                            selectLabel="Country*"
                            name="country"
                            getCountries={getCountries}
                            en={en}
                          />
                        </div>
                        <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>
                        <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 new_Input_field_Section">
                          <CurrencyPicker
                            name="currency"
                            //   value={state.currency}
                            //   onChange={selecthandleChange}
                            //   errorTrue={errors.currency === "" ? true : false}
                            //   errorText={errors.currency}
                          />
                        </div>
                        <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>
                        <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 new_Input_field_Section">
                          <TimeZoneCustom
                            name="timezone"
                            //   value={state.timezone}
                            //   onChange={onChange}
                            //   errorTrue={errors.timezone === "" ? true : false}
                            //   errorText={errors.timezone}
                          />
                        </div>
                        <div className="col-3 d-none d-md-block d-lg-block d-xl-block"></div>

                        {/* <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 restaurant_details_onboarding_country_boxone">
                          <h4>Time Zone</h4>
                        </div>
                        <div className="col-8 col-sm-8 col-md-9 col-lg-9 col-xl-9 restaurant_details_onboarding_country_boxtwo">
                          <div className="restaurant_select_country">
                            <TimeZoneCustom
                              value={ state.timezone}
                              name={"timezone"}
                              onChange={ onChange}
                              className="inside_select-box border-0"
                            />
                            <Form.Text className="text-muted input-component-bottom">
                              {errors ? (
                                <div className="text-danger text-capitalize">
                                  {errors.timezone}
                                </div>
                              ) : null}
                            </Form.Text>
                          </div>
                        </div> */}
                      </div>
                      <hr />
                      <div className="row ">
                        <div className="col-12 map-button-box-main">
                          <DropDownBoxCrret
                            //   state={dropDownBox}
                            showText="See less details"
                            hideText="See more details"
                            //   onClick={dropDownBoxClick}
                          />
                          {/* {dropDownBox ? (
                          <div className="col-12 p-0 mt-4 location-detections-popup-main h-50">
                            <div className="location-detections-popup-bodyBox">
                              <h5 className="col-12 p-0 d-flex location-detections-popup-headingfive">
                                Place ID:{" "}
                                <p className="location-detections-popup-paragraphfive">
                                  {google_place_id}
                                </p>
                              </h5>
                              <div className="row justify-content-between mt-4">
                                <div className="col-6">
                                  <NewInputText
                                    inputType="number"
                                    value={parseFloat(
                                      state.location.coordinates[0]
                                    ).toFixed(5)}
                                    labelText="Lattitude"
                                    disabled={true}

                                  />
                                </div>
                                <div className="col-6">
                                  <NewInputText
                                    inputType="number"
                                    value={parseFloat(
                                      state.location.coordinates[1]
                                    ).toFixed(5)}
                                    labelText="Longitude"
                                    disabled={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null} */}
                        </div>
                      </div>
                      <div className="onboarding-map-setup-screen-autodetect-button">
                        {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                        <Media query="(min-width: 992px)">
                          <ReusableOnboardingLink
                            buttonTitle="Back Button"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                            buttonText="Back"
                            link="/map-setup-two"
                          />
                        </Media>
                        <Media query="(max-width: 991px)">
                          <ReusableOnboardingButton
                            buttonTitle="Back Button"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                            buttonText="Back"
                            buttonType="button"
                            //   onClick={handleFormHide}
                          />
                        </Media>
                        <ReusableOnboardingButton
                          buttonTitle="Next Button"
                          buttonText="Next"
                          onClick={(e) => {
                            setDisp(1);
                          }}
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        />
                        {/* </div> */}
                      </div>
                    </div>
                  </Form>
                </div>
              )}
              {disp === 1 && (
                <div>
                  <div className="onboarding_process_screen-left-mapinside">
                    {/* <MapSetupScreenTwo /> **/}
                    <div>
                      <TopTextReusableComponent
                        headingText="Point of Contact"
                        headingParagraph="Enter the information for the Location Manager and Other Point of Contacts"
                      />
                    </div>
                    <Form noValidate>
                      <div className="point_of_contact_onboarding_main">
                        <div className="row">
                          <div className="col-6">
                            <NewInputText
                              extraClass="mt-4"
                              name="firstName"
                              inputType="text"
                              maxLength={35}
                              labelText="First Name"
                            />
                          </div>
                          <div className="col-6">
                            <NewInputText
                              extraClass="mt-4"
                              name="lastName"
                              inputType="text"
                              //   onChange={onChange}
                              //   onFocusOut={onFocusOut}
                              //   onKeyDown={InputCharacterCheck}
                              //   value={state.lastName}
                              maxLength={35}
                              //   errorText={
                              //     errors.lastName ===
                              //     "*Fields can’t be blank. Please enter your lastName"
                              //       ? "*Fields can’t be blank. Please enter your last Name"
                              //       : null
                              //   }
                              //   errorTrue={
                              //     errors.lastName ===
                              //     "*Fields can’t be blank. Please enter your lastName"
                              //       ? true
                              //       : false
                              //   }
                              labelText="Last Name"
                              //   controlClass={
                              //     errors.lastName ===
                              //     "*Fields can’t be blank. Please enter your lastName"
                              //       ? "outlined-error-helper-text"
                              //       : "outlined-helperText "
                              //   }
                            />
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ">
                                <div className="position-relative ">
                                  {/* {console.log(errors)} */}
                                  <SelectBoxMUiInputComponent
                                    extraClass={false}
                                    displayNone={true}
                                    selectLabel="Position"
                                    name="selected_position"
                                    value={""}
                                    // onChange={onChange}
                                    getData={revenueData}
                                    // errorText={errors.selected_position}
                                    // errorTrue={
                                    //   errors.selected_position === ""
                                    //     ? true
                                    //     : false
                                    // }
                                    helperText="Please select your currency"
                                  />
                                  <FormHelperText id="outlined-error-helper-text">
                                    Enter the Position for Point of Contact -
                                    this is required info
                                  </FormHelperText>
                                </div>
                              </div>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                {/* {selected_position === "Other" ? ( */}
                                {/* <NewInputText */}
                                {/* extraClass="mb-0 position-discription-mobile" */}
                                {/* name="position" */}
                                {/* inputType="text" */}
                                {/* // onChange={onChange} */}
                                {/* // onFocusOut={onFocusOut} */}
                                {/* //   onKeyDown={InputCharacterCheck} */}
                                {/* // value={state.position} */}
                                {/* // errorText={errors.position} */}
                                {/* // errorTrue={ */}
                                {/* //   errors.position === */}
                                {/* //     "*Fields can’t be blank. Please enter your position" || */}
                                {/* //   errors.position === */}
                                {/* //     "Position description is required" */}
                                {/* //     ? true */}
                                {/* //     : false */}
                                {/* // } */}
                                {/* labelText="Description of Position" */}
                                {/* // controlClass={ */}
                                {/* //   errors.position === */}
                                {/* //     "*Fields can’t be blank. Please enter your position" || */}
                                {/* //   errors.position === */}
                                {/* //     "Position description is required" */}
                                {/* //     ? "outlined-error-helper-text" */}
                                {/* //     : "outlined-helperText " */}
                                {/* // } */}
                                {/* /> */}
                                {/* ) : null} */}
                              </div>
                            </div>
                          </div>
                        </div>
                        {state.enquiry_emails.map((email, index) => (
                          <div
                            className="row align-items-center mb-4 mt-4"
                            key={index}
                          >
                            <div className="col-9">
                              <NewInputText
                                extraClass="mt-0 mb-0"
                                name="enquiry_emails"
                                inputType="email"
                                // onFocusOut={onFocusOut}
                                // onChange={onEmailChangeHandler(index)}
                                // value={email}
                                // errorText={
                                //   !validEmailRegex.test(email) &&
                                //   !isEmpty(email)
                                //     ? "Please enter a valid email"
                                //     : null ||
                                //       (email === "" &&
                                //       errors.enquiry_emails ===
                                //         "email is required"
                                //         ? "*Fields can’t be blank. Please enter your Email"
                                //         : null) ||
                                //       (email === "" &&
                                //         errors.enquiry_emails ===
                                //           "*Fields can’t be blank. Please enter your enquiry_emails")
                                //     ? "*Fields can’t be blank. Please enter your Email"
                                //     : ""
                                // }
                                // errorTrue={
                                //   (!validEmailRegex.test(email) &&
                                //     !isEmpty(email)) ||
                                //   (email === "" &&
                                //     errors.enquiry_emails ===
                                //       "email is required") ||
                                //   (email === "" &&
                                //     errors.enquiry_emails ===
                                //       "*Fields can’t be blank. Please enter your enquiry_emails")
                                //     ? true
                                //     : false
                                // }
                                labelText="Enquiry Email"
                                // controlClass={
                                //   (!validEmailRegex.test(email) &&
                                //     !isEmpty(email)) ||
                                //   (email === "" &&
                                //     errors.enquiry_emails ===
                                //       "email is required") ||
                                //   (email === "" &&
                                //     errors.enquiry_emails ===
                                //       "*Fields can’t be blank. Please enter your enquiry_emails")
                                //     ? "outlined-error-helper-text"
                                //     : "outlined-helperText"
                                // }
                              />
                            </div>
                            <div className="col-3 restaurant_details_onboarding_minus_button">
                              {state.enquiry_emails.length > 1 ? (
                                <div>
                                  <AddButtonIconComponent
                                    buttonText="Delete"
                                    // onClick={onEmailDeleteHandler(index)}
                                    fontIcon="fa fa-trash-o"
                                    colorCss="delete"
                                  />
                                </div>
                              ) : (
                                <div>
                                  <AddButtonIconComponent
                                    buttonText="Add Another"
                                    // onClick={onEmailAddHandler}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                        {state.enquiry_emails.length > 1 ? (
                          <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button">
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add Another Email"
                                // onClick={onEmailAddHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          </div>
                        ) : null}

                        {state.phone_numbers.map((phone, index) => (
                          <div
                            className="row  align-items-center mb-4"
                            key={index}
                          >
                            <div className="col-4 col-xl-3">
                              <Form.Group
                                className="reusableInputComponent-main mb-0"
                                controlId={"country_code"}
                              >
                                <div className="input-phone-country-code-reusable w-100">
                                  <select
                                    className="w-100"
                                    name="country_code"
                                    // value={phone.country_code}
                                    // onChange={onCountryCodeChangeHandler(index)}
                                  >
                                    <option
                                      value={
                                        phone.country_code === ""
                                          ? state.country_code
                                          : phone.country_code
                                      }
                                    >
                                      {phone.country_code === ""
                                        ? state.country_code
                                        : phone.country_code}
                                    </option>
                                    {getCountries().map((country) => (
                                      <option
                                        key={country}
                                        value={
                                          "+" + getCountryCallingCode(country)
                                        }
                                        // onClick={onChangeCountry}
                                      >
                                        {en[country]} (+
                                        {getCountryCallingCode(country)})
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </Form.Group>
                            </div>
                            <div className="col-5 col-xl-6 pl-0">
                              <NewInputText
                                extraClass="mb-0"
                                name="mobile_no"
                                inputType="number"
                                // onFocusOut={onFocusOut}
                                // onChange={onPhoneChangeHandler(index)}
                                // value={phone.mobile_no}
                                maxLength="10"
                                // onKeyDown={InputNumberFunc}
                                // errorText={
                                //   phone.mobile_no === "" &&
                                //   errors.mobile_no ===
                                //     "phone number is required"
                                //     ? "*Fields can’t be blank. Please enter your valid mobile number"
                                //     : "" ||
                                //       (phone.mobile_no === "" &&
                                //         errors.mobile_no ===
                                //           "*Fields can’t be blank. Please enter your mobile_no")
                                //     ? "*Fields can’t be blank. Please enter your valid mobile number"
                                //     : null ||
                                //       (phone.mobile_no.length > 0 &&
                                //         phone.mobile_no.length <= 9)
                                //     ? "Enter your valid mobile number"
                                //     : null
                                // }
                                // errorTrue={
                                //   (phone.mobile_no === "" &&
                                //     errors.mobile_no ===
                                //       "phone number is required") ||
                                //   (phone.mobile_no === "" &&
                                //     errors.mobile_no ===
                                //       "*Fields can’t be blank. Please enter your mobile_no") ||
                                //   (phone.mobile_no.length > 0 &&
                                //     phone.mobile_no.length <= 9)
                                //     ? true
                                //     : false
                                // }
                                labelText="Phone Number*"
                                // controlClass={
                                //   (phone.mobile_no === "" &&
                                //     errors.mobile_no ===
                                //       "phone number is required") ||
                                //   (phone.mobile_no === "" &&
                                //     errors.mobile_no ===
                                //       "*Fields can’t be blank. Please enter your mobile_no") ||
                                //   (phone.mobile_no.length > 0 &&
                                //     phone.mobile_no.length <= 9)
                                //     ? "outlined-error-helper-text"
                                //     : "outlined-helperText"
                                // }
                              />
                            </div>

                            <div className="col-3 restaurant_details_onboarding_minus_button">
                              {state.phone_numbers.length > 1 ? (
                                <div>
                                  <AddButtonIconComponent
                                    buttonText="Delete"
                                    // onClick={onPhoneDeleteHandler(index)}
                                    fontIcon="fa fa-trash-o"
                                    colorCss="delete"
                                  />
                                </div>
                              ) : (
                                <div>
                                  <AddButtonIconComponent
                                    buttonText="Add Another"
                                    // onClick={onPhondeAddHandler}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                        {state.phone_numbers.length > 1 ? (
                          <div className="col-12 p-0 mt-3 restaurant_details_onboarding_minus_button add_email_button">
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add Another Phone Number"
                                // onClick={onPhondeAddHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          </div>
                        ) : null}

                        <div className="onboarding-map-setup-screen-autodetect-button">
                          {state.editKey ? (
                            <ReusableOnboardingButton
                              buttonTitle="Back Button"
                              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                              buttonText="Back"
                              buttonType="button"
                              // link="/restaurantsettings"
                              //   onClick={onEditSaveHandler}
                            />
                          ) : (
                            <ReusableOnboardingButton
                              buttonTitle="Back Button"
                              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                              buttonText="Back"
                              buttonType="button"
                              //   onClick={onBackButton(props.history)}
                            />
                          )}
                          {contacts_array.length <= 0 ? (
                            <div>
                              <ReusableOnboardingButton
                                buttonTitle="Next Button"
                                buttonClass={
                                  //   firstName === "" ||
                                  //   lastName === "" ||
                                  //   // selected_position === "" ||
                                  //   // profile_Photo === "" ||
                                  //   // (selected_position === "Other" &&
                                  //   //   position === "") ||
                                  //   enquiry_emails[enquiry_emails.length - 1] ===
                                  //     "" ||
                                  //   phone_numbers[phone_numbers.length - 1]
                                  //     .mobile_no === "" ||
                                  //   phone_numbers[phone_numbers.length - 1]
                                  //     .mobile_no.length <= 9 ||
                                  //   !validEmailRegex.test(
                                  //     enquiry_emails[enquiry_emails.length - 1]
                                  //   )
                                  //     ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                  //     :
                                  "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                                  // }
                                  // disabled={
                                  //   firstName === "" ||
                                  //   lastName === "" ||
                                  //   // selected_position === "" ||
                                  //   // profile_Photo === "" ||
                                  //   // (selected_position === "Other" &&
                                  //   //   position === "") ||
                                  //   enquiry_emails[enquiry_emails.length - 1] ===
                                  //     "" ||
                                  //   phone_numbers[phone_numbers.length - 1]
                                  //     .mobile_no === "" ||
                                  //   phone_numbers[phone_numbers.length - 1]
                                  //     .mobile_no.length <= 9 ||
                                  //   !validEmailRegex.test(
                                  //     enquiry_emails[enquiry_emails.length - 1]
                                  //   ) ||
                                  //   error
                                  //     ? true
                                  //     : false
                                }
                                buttonText="Next"
                                // onClick={
                                //   actionButton === false ? withOutApiCall : null
                                // }
                                // buttonType={
                                //   actionButton === false ? "button" : "submit"
                                // }
                              />
                            </div>
                          ) : (
                            <div>
                              {state.editKey ? (
                                <ReusableOnboardingButton
                                  buttonTitle="Save Button"
                                  buttonClass={
                                    //     firstName === "" ||
                                    //     lastName === "" ||
                                    //     // selected_position === "" ||
                                    //     // profile_Photo === "" ||
                                    //     // (selected_position === "Other" &&
                                    //     //   position === "") ||
                                    //     enquiry_emails[
                                    //       enquiry_emails.length - 1
                                    //     ] === "" ||
                                    //     phone_numbers[phone_numbers.length - 1]
                                    //       .mobile_no === "" ||
                                    //     phone_numbers[phone_numbers.length - 1]
                                    //       .mobile_no.length <= 9 ||
                                    //     !validEmailRegex.test(
                                    //       enquiry_emails[enquiry_emails.length - 1]
                                    //     ) ||
                                    //     error
                                    //       ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                    //   :
                                    "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                                  }
                                  //   disabled={
                                  //     firstName === "" ||
                                  //     lastName === "" ||
                                  //     // selected_position === "" ||
                                  //     // profile_Photo === "" ||
                                  //     // (selected_position === "Other"
                                  //     //   ? position === ""
                                  //     //   : null) ||
                                  //     enquiry_emails[
                                  //       enquiry_emails.length - 1
                                  //     ] === "" ||
                                  //     phone_numbers[phone_numbers.length - 1]
                                  //       .mobile_no === "" ||
                                  //     phone_numbers[phone_numbers.length - 1]
                                  //       .mobile_no.length <= 9 ||
                                  //     !validEmailRegex.test(
                                  //       enquiry_emails[enquiry_emails.length - 1]
                                  //     ) ||
                                  //     error
                                  //       ? true
                                  //       : false
                                  //   }
                                  buttonText="Save"
                                  buttonType="button"
                                  //   onClick={onEditSaveHandler}
                                />
                              ) : (
                                <ReusableOnboardingButton
                                  buttonTitle="Next three Button"
                                  buttonClass={`onboarding_button_link_reusable 
                                   ${
                                     //     point_of_contact_error_check(state, error)
                                     //       ? "onboarding_button_link_reusable_gray ml-3"
                                     //       :
                                     "onboarding_button_link_reusable_red ml-3"
                                   }
                                `}
                                  //   disabled={
                                  //     point_of_contact_error_check(state, error)
                                  //       ? true
                                  //       : false
                                  //   }
                                  buttonText="Next"
                                  //   onClick={
                                  //     actionButton === false
                                  //       ? withOutApiCall
                                  //       : null
                                  //   }
                                  //   buttonType={
                                  //     actionButton === false ? "button" : "submit"
                                  //   }
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              )}
              {disp === 2 && <Step2 />}
              {disp === 3 && <Step3 />}
              {disp === 4 && <Step4 />}
              {disp === 5 && <Step5 />}
              {disp === 6 && <Step6 />}
              {disp === 7 && <Step7 />}
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const Step7 = (props) => {
  const [showMore, setshowMore] = useState(true);
  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = [];
    // let oldData = formikStep3.values.images;
    let newData = e;
    let mergedData = oldData.concat(newData);
    // setBank_Information(mergedData);
    // formikStep3.setFieldValue("images", mergedData);
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    // if (formikStep3.values.images.length + e.target.files.length > 6) {
    if (e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }

      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        //let allPicures = bank_informaion;
        let allPicures = [];
        // let allPicures = formikStep3.values.images;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            // docs.push(e.target.files[i]);
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        // if (docs) {
        //   axios
        //     .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        //     .then((res) => {
        //       // let oldData = bank_informaion;
        //       let oldData = formikStep3.values.images;
        //       let newData = res.data;
        //       let mergedData = oldData.concat(newData);
        //       // setBank_Information(mergedData);
        //       formikStep3.setFieldValue("images", mergedData);
        //       Alert.success(`<h4> Image Upload Successfully</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     })
        //     .catch((err) => {
        //       // this.setState({ bankImageLoader: false });
        //       Alert.error(`<h4>${err}</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     });
        // }
      } else {
        // this.setState({ bankImageLoader: false });
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    // let allImages = formikStep3.values.images.filter((item, index) => {
    //   return index !== indexId;
    // });
    // formikStep3.setFieldValue("images", allImages);
    //setBank_Information(allBankDetails);
  };

  return (
    <div>
      <div className="mt-3 mb-3 f18-500">
        Non-Profit Organization Bank Details
      </div>
      <div className="mt-3 mb-3 f14-400">
        Please Enter Non-Profit Org Information only some of this information is
        displayed to the end User
      </div>
      <div className="mt-3 mb-3 f18-500">Bank Account Info</div>
      <div className="mt-3 mb-3">
        <div className="row">
          <div className="col-5">
            <TextField
              variant="outlined"
              label="Name on Bank Account"
              fullWidth
            />
          </div>
        </div>
      </div>
      <div className="mt-3 mb-3 f18-500">Account Type?</div>
      <div className="mt-3 mb-3">
        <div className="d-flex align-items-center">
          <div>
            <input type="radio" />
          </div>
          <div className=" ml-3 f14-500">Current Account</div>
          <div className="ml-4">
            <input type="radio" />
          </div>
          <div className="ml-3 f14-500">Savings Account</div>
        </div>
      </div>
      <div className="row">
        <div className="col-5">
          <div className="mt-3 mb-3">
            <TextField variant="outlined" label="Account Number" fullWidth />
          </div>
          <div className="mt-3 mb-3">
            <TextField variant="outlined" label="IFSC Code" fullWidth />
          </div>
          <div className="mt-3 mb-3">
            <TextField variant="outlined" label="Branch Name" fullWidth />
          </div>
        </div>
      </div>

      <div className="mt-3 mb-3 f18-500">Upload Relevant Documents</div>
      <div className="mt-3 mb-3 f14-400">
        (Upload supporting documents such as a Cancelled Cheque, Bank Statement
        as applicable) - You may receive a call for KYC and Confirmation
      </div>
      <SimpleReactLightbox>
        <MultipleImageUploadComponent
          title="Upload Item Images"
          // smallTitle="(Upload supporting documents such as a Cancelled Cheque, Bank Statement as applicable) - You may receive a call for KYC and Confirmation"
          onChange={bankUploadMultipleFiles}
          //stateValue={bank_informaion}
          stateValue={[]}
          // stateValue={formikStep3.values.images}
          newUploaded={restaurant_pictures_new ? restaurant_pictures_new : []}
          combined={combined}
          onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
          removeImage={bankDocMultipleRemove}
          accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
          // loader={state.bankImageLoader}
        />
      </SimpleReactLightbox>
      <div className="f12-500 mt-3">Show added Tax and Surcharges </div>
      {showMore && (
        <React.Fragment>
          <div className="row mt-4 mb-3">
            <div className="col-1">
              <div className="f12-400">No.</div>
            </div>
            <div className="col-2">
              <div className="f12-400">Name on Account</div>
            </div>
            <div className="col-2">
              <div className="f12-400">Type of Account</div>
            </div>
            <div className="col-2">
              <div className="f12-400">
                Account Number /<br />
                IFSC Code
              </div>
            </div>
            <div className="col-2">
              <div className="f12-400">
                Transaction
                <br />
                Group / Actions
              </div>
            </div>
            <div className="col-2">
              <div className="f12-400">
                Branch Name /
                <br />
                Documents
              </div>
            </div>
          </div>
          <div className="row mt-4 mb-3">
            <div className="col-1">
              <div className="f12-500">1</div>
            </div>
            <div className="col-2">
              <div className="f12-500">
                Ram Bharose Resturantant Pune India Limited
              </div>
            </div>
            <div className="col-2">
              <div className="f12-500">Current Account</div>
            </div>
            <div className="col-2">
              <div className="f12-500">1234578912345678900</div>
              <div className="f10-400">Account Number</div>

              <div className="mt-2 f12-500">1234578912345678900</div>
              <div className="f10-400">Account Number</div>
            </div>
            <div className="col-2">
              <div className="f12-500">Scan & Pay</div>
              <div>
                <div className="col-4 d-flex">
                  <IconButton
                    className="mr-2 p-0"
                    //   onClick={this.onEditButtonCLickHandler(contact.id)}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/editBlue.svg")}
                      alt="add"
                      title="add"
                      className="w-20px"
                    />
                  </IconButton>

                  <IconButton
                    className="p-0"
                    //   onClick={this.onClickContactDelete(contact.id)}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/delete-gray.svg")}
                      alt="add"
                      title="add"
                      className="w-20px"
                    />
                  </IconButton>
                </div>
              </div>
            </div>
            <div className="col-2">
              <div className="f12-500">Magarpatta Branch, Kalyaninagar</div>
            </div>
          </div>
        </React.Fragment>
      )}
      <div>
        <div class="d-flex mt-3 mb-4">
          <button
            class="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            title="Back Button"
          >
            Back
          </button>
          <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            title="Next Button"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

const Step6 = (props) => {
  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = [];
    // let oldData = formikStep3.values.images;
    let newData = e;
    let mergedData = oldData.concat(newData);
    // setBank_Information(mergedData);
    // formikStep3.setFieldValue("images", mergedData);
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    // if (formikStep3.values.images.length + e.target.files.length > 6) {
    if (e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }

      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        //let allPicures = bank_informaion;
        let allPicures = [];
        // let allPicures = formikStep3.values.images;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            // docs.push(e.target.files[i]);
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        // if (docs) {
        //   axios
        //     .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        //     .then((res) => {
        //       // let oldData = bank_informaion;
        //       let oldData = formikStep3.values.images;
        //       let newData = res.data;
        //       let mergedData = oldData.concat(newData);
        //       // setBank_Information(mergedData);
        //       formikStep3.setFieldValue("images", mergedData);
        //       Alert.success(`<h4> Image Upload Successfully</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     })
        //     .catch((err) => {
        //       // this.setState({ bankImageLoader: false });
        //       Alert.error(`<h4>${err}</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     });
        // }
      } else {
        // this.setState({ bankImageLoader: false });
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    // let allImages = formikStep3.values.images.filter((item, index) => {
    //   return index !== indexId;
    // });
    // formikStep3.setFieldValue("images", allImages);
    //setBank_Information(allBankDetails);
  };

  return (
    <div>
      <div className="mt-3 mb-3 f18-500">
        Non- Profit KYC and License Information
      </div>
      <div className="mt-3 mb-3 f14-400">
        Enter the details about your Non- Profit Establishment
      </div>
      <div className="mt-3 mb-3 f18-500">KYC and License Info</div>
      <div className="row">
        <div className="col-5">
          <div className="mt-3 mb-3">
            <TextField variant="outlined" label="GST Number" fullWidth />
          </div>
          <div className="mt-3 mb-3">
            <TextField variant="outlined" label="Non- Number" fullWidth />
          </div>
          <div className="mt-3 mb-3">
            <TextField variant="outlined" label="PAN/ Tax Number" fullWidth />
          </div>
        </div>
      </div>
      <SimpleReactLightbox>
        <MultipleImageUploadComponent
          title="Upload Item Images"
          // smallTitle="(Upload supporting documents such as a Cancelled Cheque, Bank Statement as applicable) - You may receive a call for KYC and Confirmation"
          onChange={bankUploadMultipleFiles}
          //stateValue={bank_informaion}
          stateValue={[]}
          // stateValue={formikStep3.values.images}
          newUploaded={restaurant_pictures_new ? restaurant_pictures_new : []}
          combined={combined}
          onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
          removeImage={bankDocMultipleRemove}
          accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
          // loader={state.bankImageLoader}
        />
      </SimpleReactLightbox>
      <div>
        <div class="d-flex mt-3 mb-4">
          <button
            class="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            title="Back Button"
          >
            Back
          </button>
          <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            title="Next Button"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

const Step5 = (props) => {
  const [logo_url, setLogoUrl] = useState(null);
  const [combined, setCombined] = useState(null);
  const [logo_main, setLogoMain] = useState(null);
  const onCompleteCrop = (url) => {
    setLogoUrl(url);
    // formik.setFieldValue(`details_nutritions.nutritional_image[0]`, url);
    onCancelCrop();
  };

  const onCancelCrop = () => {
    setLogoMain("");
  };

  const onImageLogoUploadHandler = (e) => {
    try {
      // setState({ singleImageLoader: true });
      // if (e.target.files) {
      // console.log(e.target.files, this.state);
      const vendor_id = props.auth.user.VendorUser._id;
      const restaurant_name = props.onboarding.restaurant_name
        .split(" ")
        .join("");
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      data.append("files", e.target.files[0]);
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        setLogoMain(e.target.files[0]);
        setCombined(combined);
      }
      e.target.value = "";
    } catch (err) {
      console.log(err);
    }
    // }
  };

  const removeFile = () => {
    setLogoUrl(null);
    // formik.setFieldValue(`details_nutritions.nutritional_image[0]`, "");
  };

  return (
    <div>
      <div className="mt-3 mb-3 f18-500">
        Non-Profit Organization Group Set up
      </div>
      <div className="mt-3 mb-3 f14-400">
        Enter the details about your Non- Profit Establishment
      </div>
      <div className="mt-3 mb-3">
        <TextField variant="outlined" label="Location Code" />
      </div>
      <div className="mt-3 mb-3 f18-500">Business Chain Details</div>
      <div className="mt-3 mb-3 f14-400">
        Please enter details about your Business chain
      </div>
      <div className="mt-3 mb-3">
        <TextField variant="outlined" label="Business Chain" />
      </div>
      <div className="mt-3 mb-3">
        <TextField
          variant="outlined"
          label="Head Office Address"
          multiline
          rows="4"
          fullWidth
        />
        <div className="mt-2 f12-400">
          Street Address - Required Info Enter name as it appears on your store
          front - Required Info
        </div>
      </div>
      <div className="row mb-3 mt-3">
        <div className="col-3">
          <TextField variant="outlined" label="Area*" fullWidth />
        </div>
        <div className="col-3">
          <TextField variant="outlined" label="City*" fullWidth />
        </div>
        <div className="col-3">
          <TextField variant="outlined" label="Pin/Zip code*" fullWidth />
        </div>
      </div>
      <div className="row mb-3 mt-3">
        <div className="col-7">
          <TextField variant="outlined" fullWidth label="Email*" />
        </div>
        <div className="col-3">
          <button class="add-button-icon-reusable add-button-icon-reusable-blue">
            <svg
              class="MuiSvgIcon-root"
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
              style={{
                fontSize: "21px",
                color: "rgb(255, 255, 255)",
                backgroundColor: "rgb(32, 150, 242)",
                borderRadius: "24px",
                marginRight: "5px",
              }}
            >
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
            </svg>
            Add Another
          </button>
        </div>
      </div>
      <div className="row  align-items-center mb-4 mt-4">
        <div className="col-2 col-xl-3">
          <Form.Group
            className="reusableInputComponent-main mb-0"
            controlId={"country_code"}
          >
            <div className="input-phone-country-code-reusable w-100">
              <select
                className="w-100"
                name="country_code"
                // value={phone.country_code}
                // onChange={this.onCountryCodeChangeHandler(index)}
              >
                {/* <option
                  value={
                    phone.country_code === ""
                      ? this.state.country_code
                      : phone.country_code
                  }
                >
                  {phone.country_code === ""
                    ? this.state.country_code
                    : phone.country_code}
                </option> */}
                {getCountries().map((country) => (
                  <option
                    key={country}
                    value={"+" + getCountryCallingCode(country)}
                    // onClick={this.onChangeCountry}
                  >
                    {en[country]} (+
                    {getCountryCallingCode(country)})
                  </option>
                ))}
              </select>
            </div>
          </Form.Group>
        </div>
        <div className="col-5 col-xl-6 pl-0 ">
          <NewInputText
            extraClass="mb-0"
            name="mobile_no"
            inputType="number"
            // onFocusOut={this.onFocusOut}
            // onChange={this.onPhoneChangeHandler(index)}
            // value={phone.mobile_no}
            maxLength="10"
            // onKeyDown={InputNumberFunc}
            // errorText={
            //   phone.mobile_no === "" &&
            //   errors.mobile_no === "phone number is required"
            //     ? "*Fields can’t be blank. Please enter your valid mobile number"
            //     : "" ||
            //       (phone.mobile_no === "" &&
            //         errors.mobile_no ===
            //           "*Fields can’t be blank. Please enter your mobile_no")
            //     ? "*Fields can’t be blank. Please enter your valid mobile number"
            //     : null ||
            //       (phone.mobile_no.length > 0 && phone.mobile_no.length <= 9)
            //     ? "Enter your valid mobile number"
            //     : null
            // }
            // errorTrue={
            //   (phone.mobile_no === "" &&
            //     errors.mobile_no === "phone number is required") ||
            //   (phone.mobile_no === "" &&
            //     errors.mobile_no ===
            //       "*Fields can’t be blank. Please enter your mobile_no") ||
            //   (phone.mobile_no.length > 0 && phone.mobile_no.length <= 9)
            //     ? true
            //     : false
            // }
            labelText="Phone Number*"
            // controlClass={
            //   (phone.mobile_no === "" &&
            //     errors.mobile_no === "phone number is required") ||
            //   (phone.mobile_no === "" &&
            //     errors.mobile_no ===
            //       "*Fields can’t be blank. Please enter your mobile_no") ||
            //   (phone.mobile_no.length > 0 && phone.mobile_no.length <= 9)
            //     ? "outlined-error-helper-text"
            //     : "outlined-helperText"
            // }
          />
        </div>

        <div className="col-3 restaurant_details_onboarding_minus_button">
          {[].length > 1 ? (
            //   {this.state.phone_numbers.length > 1 ? (
            <div>
              <AddButtonIconComponent
                buttonText="Delete"
                // onClick={this.onPhoneDeleteHandler(index)}
                fontIcon="fa fa-trash-o"
                colorCss="delete"
              />
            </div>
          ) : (
            <div>
              <AddButtonIconComponent
                buttonText="Add Another"
                // onClick={this.onPhondeAddHandler}
                fontIcon="fa fa-plus"
                colorCss="blue"
              />
            </div>
          )}
        </div>
      </div>
      <SimpleReactLightbox>
        <SingleImageReusableComponent
          title="Add Logo*"
          // smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
          // onDrop={this.onSingleImageDrop}
          onChange={onImageLogoUploadHandler}
          combined={combined && combined}
          onCompleteCrop={onCompleteCrop}
          onCancelCrop={onCancelCrop}
          file={
            (logo_main && logo_main !== null && logo_main) ||
            (logo_url && logo_url)
          }
          resetFile={removeFile}
          name="logo_url"
          //   error={errors.logo_url}
          // loader={singleImageLoader}
        />
        <div className="font_12_r c_gray mb-4 mt-3">
          Only .jpg and .png files. 500kb max file size
        </div>
      </SimpleReactLightbox>
      <div>
        <div class="d-flex mt-3 mb-4">
          <button
            class="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            title="Back Button"
          >
            Back
          </button>
          <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            title="Next Button"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

const Step4 = (props) => {
  return (
    <div>
      <div className="mt-3 mb-3 f18-500">
        Non-Profit Organization Group Set up
      </div>
      <div className="mt-3 mb-3 f14-400">
        Enter the details about your Non- Profit Establishment
      </div>
      <div className="row">
        <div className="col-8">
          <div className="mt-3 mb-3 f18-500">Are you part of a chain?</div>
        </div>
        <div className="col-8">
          <Switch />
        </div>
      </div>{" "}
      <div className="mt-3 mb-3 f14-400">
        (Select this if you are part of a chain and request if new ones needs to
        be set up)
      </div>
      <div className="row">
        <div className="mt-3 mb-3 col-4">
          <TextField label="Location Code" variant="outlined" fullWidth />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <TextField
            label="Search below your chain using name or code"
            variant="outlined"
            fullWidth
          />
          <div class="suggest-button-heading">
            <button class="add-button-icon-reusable add-button-icon-reusable-red">
              <svg
                class="MuiSvgIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
                aria-hidden="true"
                style={{
                  fontSize: "21px",
                  color: "rgb(255, 255, 255)",
                  backgroundColor: "rgb(238, 58, 35)",
                  borderRadius: "24px",
                  marginRight: "5px",
                }}
              >
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
              </svg>
              Set Up New
            </button>
          </div>
        </div>
        <div className="col-4"></div>
      </div>
      <div className="f14-500">Select your chain</div>
      <div className="f12-400">
        Select a Chain your Business establishment belongs
      </div>
      <div className="row">
        <div className="col-8">
          <div className="restaurant_type_onboarding_main">
            <div className="cuisine-main ">
              <div class="cuisine-main-padding-border">
                <div
                  id="box-style"
                  class="cuisine-main-padding justify-content-start column-2"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  <div class="position-relative mt-3">
                    <div class="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type">
                      <img
                        src="https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-140-0002%20Airport.png"
                        alt="icon"
                        title="Airport"
                      />
                      <span
                        class="para-data-icon"
                        style={{ color: "rgb(33, 33, 33)" }}
                      >
                        Airport
                      </span>
                    </div>
                  </div>
                  <div class="position-relative mt-3">
                    <div class="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle">
                      <img
                        src="https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-140-0003%20Apartment-Housing.png"
                        alt="icon"
                        title="Apartment / Housing"
                      />
                      <span
                        class="para-data-icon"
                        style={{ color: "rgb(33, 33, 33)" }}
                      >
                        Apartment / Housing
                      </span>
                    </div>
                  </div>
                  <div class="position-relative mt-3">
                    <div class="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle">
                      <img
                        src="https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-140-0001%20Bus%20station.png"
                        alt="icon"
                        title="Bus Station"
                      />
                      <span
                        class="para-data-icon"
                        style={{ color: "rgb(33, 33, 33)" }}
                      >
                        Bus Station
                      </span>
                    </div>
                  </div>
                  <div class="position-relative mt-3">
                    <div class="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle">
                      <img
                        src="https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-140-0004%20Cinema.png"
                        alt="icon"
                        title="Cinema "
                      />
                      <span
                        class="para-data-icon"
                        style={{ color: "rgb(33, 33, 33)" }}
                      >
                        Cinema{" "}
                      </span>
                    </div>
                  </div>
                  <div class="position-relative mt-3">
                    <div class="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type">
                      <img
                        src="https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-Asset%2013%404x.png"
                        alt="icon"
                        title="City Center"
                      />
                      <span
                        class="para-data-icon"
                        style={{ color: "rgb(33, 33, 33)" }}
                      >
                        City Center
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex">
          <button
            class="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            title="Back Button"
          >
            Back
          </button>
          <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            title="Next Button"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
const Step3 = (props) => {
  const [logo_url, setLogoUrl] = useState(null);
  const [combined, setCombined] = useState(null);
  const [logo_main, setLogoMain] = useState(null);
  const onCompleteCrop = (url) => {
    setLogoUrl(url);
    // formik.setFieldValue(`details_nutritions.nutritional_image[0]`, url);
    onCancelCrop();
  };

  const onCancelCrop = () => {
    setLogoMain("");
  };

  const onImageLogoUploadHandler = (e) => {
    try {
      // setState({ singleImageLoader: true });
      // if (e.target.files) {
      // console.log(e.target.files, this.state);
      const vendor_id = props.auth.user.VendorUser._id;
      const restaurant_name = props.onboarding.restaurant_name
        .split(" ")
        .join("");
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      data.append("files", e.target.files[0]);
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        setLogoMain(e.target.files[0]);
        setCombined(combined);
      }
      e.target.value = "";
    } catch (err) {
      console.log(err);
    }
    // }
  };

  const removeFile = () => {
    setLogoUrl(null);
    // formik.setFieldValue(`details_nutritions.nutritional_image[0]`, "");
  };

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  //   const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = [];
    // let oldData = formikStep3.values.images;
    let newData = e;
    let mergedData = oldData.concat(newData);
    // setBank_Information(mergedData);
    // formikStep3.setFieldValue("images", mergedData);
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    // if (formikStep3.values.images.length + e.target.files.length > 6) {
    if (e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }

      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        //let allPicures = bank_informaion;
        let allPicures = [];
        // let allPicures = formikStep3.values.images;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            // docs.push(e.target.files[i]);
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        // if (docs) {
        //   axios
        //     .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
        //     .then((res) => {
        //       // let oldData = bank_informaion;
        //       let oldData = formikStep3.values.images;
        //       let newData = res.data;
        //       let mergedData = oldData.concat(newData);
        //       // setBank_Information(mergedData);
        //       formikStep3.setFieldValue("images", mergedData);
        //       Alert.success(`<h4> Image Upload Successfully</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     })
        //     .catch((err) => {
        //       // this.setState({ bankImageLoader: false });
        //       Alert.error(`<h4>${err}</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     });
        // }
      } else {
        // this.setState({ bankImageLoader: false });
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    // let allImages = formikStep3.values.images.filter((item, index) => {
    //   return index !== indexId;
    // });
    // formikStep3.setFieldValue("images", allImages);
    //setBank_Information(allBankDetails);
  };

  // Video upload

  const [progress, setProgress] = React.useState(0);
  const uploadVideo = (e) => {
    if (e.target.files && e.target.files[0].size) {
      if (e.target.files[0].size > videoUploadSize) {
        alert("File is too Big");
      } else {
        //setLoading(true);
        const data = new FormData();
        data.append("file", e.target.files[0]);
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              setProgress((progressEvent.loaded / progressEvent.total) * 100);
            },
          })
          .then((res) => {
            //setLoading(false);
            Alert.success(`<h4>Video uploaded sucessfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });

            //setVideo(res.data[0]);
            //formik.setFieldValue("photos", res.data[0]);
            // formikStep3.setFieldValue(`videos[0]`, res.data);
          })
          .catch((err) => {
            Alert.error(`<h4>Error while uploading the video</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };
  const removeVideo = () => {
    // formikStep3.setFieldValue(`videos[0]`, null);
  };

  return (
    <div>
      <div className="mt-3 mb-3 f18-500">Non-Profit Organization Details </div>
      <div className="mt-3 mb-3 f14-400">
        Please Enter Non-Profit Org Information only some of this information is
        displayed to the end User
      </div>
      <div className="mt-3 mb-3 mr-4">
        <TextField
          label="Description and Details about your business keep min of 100 characters or more*"
          variant="outlined"
          fullWidth
          multiline
          rows="4"
        />
        <div className="mt-2 f12-400">
          Enter elaborate information about the Business to convey to your
          Audience group.
        </div>
      </div>
      <div className="mt-3 mb-3">
        <SimpleReactLightbox>
          <SingleImageReusableComponent
            title="Add Logo*"
            // smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
            // onDrop={this.onSingleImageDrop}
            onChange={onImageLogoUploadHandler}
            combined={combined && combined}
            onCompleteCrop={onCompleteCrop}
            onCancelCrop={onCancelCrop}
            file={logo_main !== "" ? logo_main : logo_url}
            resetFile={removeFile}
            name="logo_url"
            // error={errors.logo_url}
            // loader={state.singleImageLoader}
          />
          <div className="font_12_r c_gray mb-4 mt-3">
            Only .jpg and .png files. 500kb max file size
          </div>
        </SimpleReactLightbox>
        <SimpleReactLightbox>
          <MultipleImageUploadComponent
            title="Upload Item Images"
            // smallTitle="(Upload supporting documents such as a Cancelled Cheque, Bank Statement as applicable) - You may receive a call for KYC and Confirmation"
            onChange={bankUploadMultipleFiles}
            //stateValue={bank_informaion}
            stateValue={[]}
            // stateValue={formikStep3.values.images}
            newUploaded={restaurant_pictures_new ? restaurant_pictures_new : []}
            combined={combined}
            onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
            removeImage={bankDocMultipleRemove}
            accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
            // loader={state.bankImageLoader}
          />
        </SimpleReactLightbox>
        <Form.Group className="pb-4">
          <Form.Label className="f14-500 mb-2">Upload Videos</Form.Label>
          <div className="d-flex flex-wrap">
            <div className="enUploadBox">
              <Image
                src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                alt="uploadImg"
                title="uploadImg"
                fluid
              />
              <input type="file" accept=".mp4" onChange={uploadVideo} />
            </div>
            {[].length > 0 && (
              // {formikStep3.values.videos.length > 0 && (
              <Slider
                {...settings}
                className={`sliderUploadImges video-upload`}
                // style={videoUpload && { width: "226px" }}
              >
                <div className="enIconUploaded">
                  <button
                    type="button"
                    className="enCloseButton"
                    onClick={() => removeVideo()}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/en_close.svg")}
                      alt="removeVideo"
                      title="removeVideo"
                      fluid
                    />
                  </button>
                  <video width="100%" height="100%" controls>
                    <source
                      src={""}
                      //   src={formikStep3.values.videos[0]}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </Slider>
            )}
          </div>
        </Form.Group>
        {!progress && progress === 0 ? null : (
          <AlertDialogProgress progress={progress} title="Video Uploading..." />
        )}
      </div>
      <div class="d-flex">
        <button
          type="button"
          class="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          title="Back Button"
        >
          Back
        </button>
        <button
          type="button"
          class="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
          title="Next Button"
        >
          Next
        </button>
      </div>
    </div>
  );
};

const Step2 = (props) => {
  const renderButtonsandFields = () => {
    return (
      <div className="restaurant_type_onboarding_main">
        <div className="onboarding_process_screen-button-map onboarding_process_screen-left-mapinside">
          <div className="cuisine-main restaurant-type-display-mobile-margin mb-0">
            <div
            //   className={
            // this.state.all_restauranttype_icons.length > 8
            //   ? "cuisine-main-padding-border"
            //   : ""
            //   }
            >
              <div
                id="box-style"
                className="cuisine-main-padding column-2"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {[].map((icon, index) => (
                  // {this.state.all_restauranttype_icons.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                    src={icon.icon}
                    title={icon.title}
                    // onClick={this.onRestaurantSelectorArraySelector(
                    //   icon,
                    //   index
                    // )}
                  />
                ))}
              </div>
            </div>
            <div className="suggest-button-heading">
              {/* <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d0a"} /> */}
            </div>

            {/** */}
            {false ? (
              // {!isEmpty(selected_restaurant_type) ? (
              <React.Fragment>
                <div className="f14-500 mt-4">
                  Out of the selections below, which one is primary?
                </div>
                <div className="f11-400 opacity5">
                  Select only one of the options below as a default - this is
                  shown to the user.
                </div>
              </React.Fragment>
            ) : null}

            <div
              // id="box-style"
              className="cuisine-main-padding-bottom column-2 mt-4"
              style={{ display: "flex", flexWrap: "wrap" }}
            >
              {[].map((icon, index) => (
                //   {selected_restaurant_type.map((icon, index) => (
                <ReusableOnboardingMapButton
                  key={index}
                  classsection={
                    // icon._id === primary_restaurant_type._id
                    //   ?
                    "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                    // : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                  }
                  src={icon.icon}
                  title={icon.title}
                  //   onClick={this.onRestaurantsPrimarySelector(icon)}
                  //   displayPrimary={
                  //     icon._id === primary_restaurant_type._id ? true : false
                  //   }
                  displayRemove={true}
                  //   removeButtonClick={this.removeButton(icon, index)}
                />
              ))}
            </div>
          </div>
        </div>
        <div>
          {/* </div> */}
          <div className="onboarding-map-setup-screen-autodetect-button ">
            <Media query="(min-width: 992px)">
              <ReusableOnboardingLink
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                link="#"
              />
            </Media>
            <Media query="(max-width: 991px)">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                buttonType="button"
                // onClick={this.handleFormHide}
              />
            </Media>
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                // selected_restaurant_type.length <= 0 ||
                // isEmpty(primary_restaurant_type) ||
                // cost_for_two === "" ||
                // revenue === ""
                //   ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                //   :
                "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              //   disabled={
              //     selected_restaurant_type.length <= 0 ||
              //     isEmpty(primary_restaurant_type) ||
              //     cost_for_two === "" ||
              //     revenue === ""
              //       ? true
              //       : false
              //   }
              buttonText="Next"
              //   onClick={actionButton === false ? this.onWithOutApiCall : null}
              //   buttonType={actionButton === false ? "button" : "submit"}
            />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="">
      <div className="onboarding_process_screen-left-mapinside">
        <TopTextReusableComponent
          headingText="Business Type"
          headingParagraph="(Select the type of Business Establishment you are, you can select multiple and define one default - this is required info)"
        />
      </div>
      <Form noValidate>{renderButtonsandFields()}</Form>
    </div>
  );
};

export default SuperAdminAddNonProfitOrg;
